<template>
  <div>
    <div class="form-group row" v-if="!multiple">
      <label class="col-sm-4 col-form-label">
        {{ c.label }}<small v-if="c.required" class="text-danger">*</small>
      </label>
      <div class="col-sm-8 my-auto">
        <input
          v-if="!confirm"
          v-model="visitor_forms[c.id]"
          type="number"
          step="0.1"
          :required="c.required ? true : false"
          class="form-control"
          :placeholder="c.placeholder"
        />
        <p v-if="confirm" class="mb-0">{{ visitor_forms[c.id] }}</p>

        <!-- For data aggregation -->
        <template v-if="guestLength > 0 && !confirm">
          <template v-for="(companion, index) in companions">
            <input
              v-if="!confirm && different.includes(c.system_name)"
              v-model="companion.other_forms[c.id]"
              type="number"
              step="0.1"
              :required="c.required ? true : false"
              class="form-control mt-3"
              :placeholder="
                showLabelOrPlaceholder(
                  $t('visit-information-form.companion'),
                  index,
                  c.placeholder,
                  'placeholder'
                )
              "
            />
          </template>
        </template>
      </div>
    </div>

    <!-- Multiple Room -->
    <div class="form-group row" v-else>
      <label class="col-sm-4 col-form-label">
        {{ c.label }}<small v-if="c.required" class="text-danger">*</small>
      </label>
      <div class="col-sm-8">
        <input
          v-if="!confirm"
          v-model="multiple_data[bd_index].visitor_forms[c.id]"
          type="number"
          step="0.1"
          :required="
            multiple_data[bd_index].filled_in_by_other
              ? false
              : c.required
              ? true
              : false
          "
          class="form-control"
          :placeholder="c.placeholder"
        />
        <p v-if="confirm">{{ multiple_data[bd_index].visitor_forms[c.id] }}</p>

        <!-- For data aggregation -->

        <template
          v-if="multiple_data[bd_index].companions.length > 0 && !confirm"
        >
          <template
            v-for="(companion, index) in multiple_data[bd_index].companions"
          >
            <input
              v-if="!confirm && different.includes(c.system_name)"
              v-model="companion.other_forms[c.id]"
              type="number"
              step="0.1"
              :required="c.required ? true : false"
              class="form-control mt-3"
              :placeholder="
                showLabelOrPlaceholder(
                  $t('visit-information-form.companion'),
                  index,
                  c.placeholder,
                  'placeholder',
                  true,
                  bd_index
                )
              "
        
            />
          </template>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { main_form_methods } from "../../../../utils/mockup";
const { 
  showLabelOrPlaceholder, 
  populateCompanionsFields, 
  isFixGuestEnabled,
  checkAddCompanions,
  isRsvForm,
  getLength
} = main_form_methods;
import guestWatcherMixin from "../../../../../../mixins/guestWatcherMixin";

export default {
  props: {
    c: null,
    confirm: false,
    visitor_forms: {
      type: Object,
      default: {},
    },
    companions: {
      type: Array,
      default: [],
    },
    different: {
      type: Array,
      default: [],
    },
    questions: {
      type: Array,
      default: [],
    },
    // Multiple room
    multiple: false,
    multiple_data: {
      type: Array,
      default: [],
    },
    bd_index: null,
    // End of multiple room
    // checkin form type
    checkin_form_type: "",
    reservation_no: null,
    fixGuestCount: {
      type: Number,
      default: null
    },
    fixGuestSetting: {
      type: Object,
      default: {}
    }
  },
  mixins: [guestWatcherMixin],
  data() {
    return {
      formType: "",
      allowAddingCompanions: true,
      guestLength: 0
    }
  },
  computed: {
    isFixGuestEnabled,
    isRsvForm,
    getLength
    // fixGuestLength() {
    //   this.guestLength = this.fixGuestCount
    // },
  },
  async created() {
    await this.initializeForm();
  },
  methods: {
    async initializeForm() {
      const isRsvForm = await this.isRsvForm
      const isFixGuestEnabled = await this.isFixGuestEnabled
      
      this.allowAddingCompanions = this.checkAddCompanions(isRsvForm, isFixGuestEnabled);
      this.populateCompanionsFields();
    },
    showLabelOrPlaceholder,
    populateCompanionsFields,
    checkAddCompanions,
  },
};
</script>